module.exports = __webpack_public_path__ + "img/icon01.6a6b63e3.png";